module.exports = __webpack_public_path__ + "6b2b4b7f1c541d1dc1cf95e6c375de86.svg";